import React from 'react';
import { Formik, Form, FormikProps } from 'formik';
import Grid from '@material-ui/core/Grid/Grid';
import CommissionTerms from './../NetworkRegister/ComissionTermsForm';
import Button from '../../shared/Button/Button';
import ClubDetails from './ClubDetails';
import { ClubRegisterData } from 'store/clubs/types/types';
import validationSchema from './firstStep/validationSchema';

type Props = {
  formData: ClubRegisterData;
  handleSubmit: (clubRegisterData: ClubRegisterData) => any;
  commissionTerms: any;
  goBack: () => any;
};

const StepFirstForm: React.FC<Props> = ({ handleSubmit, formData, commissionTerms, goBack }: Props) => {
  return (
    <Formik initialValues={formData} onSubmit={handleSubmit} validationSchema={validationSchema}>
      {({ errors, touched, setFieldValue }: FormikProps<any>) => {
        return (
          <Form className="form network-register__form">
            <Grid container>
              <Grid item xs={6}>
                <ClubDetails setFieldValue={setFieldValue} />
              </Grid>
              <Grid item xs={6}>
                <CommissionTerms commisionTerms={commissionTerms} />
              </Grid>
            </Grid>
            <div className="form__navigation space-between">
              <div className="form__navigation-item">
                <Button className="form__back" type="button" label="Back" onClick={goBack} />
              </div>
              <div className="form__navigation-item">
                <Button className="form__submit" type="submit" label="Next" />
              </div>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default StepFirstForm;
